import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Hidden, IconButton } from '@material-ui/core'

import PersonIcon from '@material-ui/icons/Person'

import React, { useState } from 'react'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme =>
  createStyles({
    typography: {
      //   color: '#FFFFFF'
      color: theme.palette.primary.main
    }
  })
)

const SomeMenu = props => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState()
  const classes = useStyles()

  const username = useSelector(state => state.auth.username)

  const recordButtonPosition = event => {
    setAnchorEl(event.currentTarget)
    setMenuOpen(true)
  }

  let closeMenu = () => {
    setMenuOpen(false)
  }

  return (
    <>
      {/* <PersonIcon color="primary"></PersonIcon> */}

      <Hidden xsDown>
        <Button onClick={recordButtonPosition}>
          <Hidden xsDown>
            <Typography variant="h4" className={classes.typography}>
              {username}
            </Typography>
          </Hidden>

          {/* <Hidden smUp>
          <Typography variant="h5" className={classes.typography}>
          {username}
          </Typography>
        </Hidden> */}
        </Button>
      </Hidden>

      <Menu anchorEl={anchorEl} open={menuOpen} onClose={closeMenu}>
        <MenuItem
          onClick={() => {
            closeMenu()
          }}>
          {' '}
          <a href="/user/logout">LOGOUT</a>{' '}
        </MenuItem>
      </Menu>
    </>
  )
}

export default SomeMenu
